import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { SelectChangeEvent } from '@mui/material';

import { PoolSelect, PoolSelectProps } from './pool-select';

export interface PoolFormikSelectProps<T> extends Omit<PoolSelectProps<T>, 'onChange'> {
    name: string;
    onChange?: (value: T, helper: FieldHelperProps<T>, field: FieldInputProps<T>, meta: FieldMetaProps<T>) => void;
}

export const PoolFormikSelect = <T,>(props: PoolFormikSelectProps<T>): ReactElement => {
    const { onChange, name, ...selectProps } = props;
    const [field, meta, helper] = useField<T>({ name });

    const handleChange = (e: SelectChangeEvent<'' | T>): void => {
        field.onChange(e);
        onChange?.(e.target.value as T, helper, field, meta);
    };

    return (
        <PoolSelect<T>
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : ' '}
            {...field}
            onChange={handleChange}
            {...selectProps}
        />
    );
};
